import { IPermissionDTO } from "@interfaces/IPermissionDTO";
import { IRoleDTO } from "@interfaces/IRoleDTO";

let permissionsList: IPermissionDTO[] = [];
export function setPermissionsList(list: IPermissionDTO[]) {
  permissionsList = list;
}

export function hasPermission(
  roles: IRoleDTO[],
  routineName: string,
  functionalityName: string
): boolean {
  if (!roles || roles.length === 0) return false;

  if (roles.some((role) => role.userType === "super_admin")) return true;

  return roles.some((role) =>
    permissionsList.some(
      (p) =>
        p.role_name.toLowerCase() === role.name.toLowerCase() &&
        p.routine_name.toLowerCase() === routineName.toLowerCase() &&
        p.functionality_name.toLowerCase() === functionalityName.toLowerCase()
    )
  );
}
